module.exports = __webpack_public_path__ + "static/img/design2.38b647c4.png";